<template>
    <section class="c-case-popular">
        <div class="c-case-popular__title">
            <h2>
                {{ popularData.title2 }}
            </h2>
        </div>
        <div class="c-case-popular__brands-wrapper">
            <div
                id="case-studies"
                class="c-case-popular__brands"
            >
                <img
                    v-for="brand in popularData.albums"
                    :key="brand.id"
                    :src="brand.link"
                    :alt="brand.title"
                >
            </div>
        </div>
    </section>
</template>

<script >

    export default {
        name: 'CaseStudiesPopular',

        /**
         *
         * @inheritDoc
         */
        props: {
            popularData: {
                type    : Object,
                required: true,
            },
        },
    };

</script>

<style lang="scss" src="./popular-client.scss"/>
